import React from 'react';
import { Search } from 'lucide-react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}
export function Input({
  className = '',
  label,
  error,
  icon,
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-139">
      {label && <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-140">
          {label}
        </label>}
      <div className="relative" data-id="element-141">
        {icon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400" data-id="element-142">
            {icon}
          </div>}
        <input className={`block w-full rounded-lg border-slate-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm disabled:bg-slate-50 disabled:text-slate-500 ${icon ? 'pl-10' : 'pl-3'} ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : ''} ${className}`} {...props} data-id="element-143" />
      </div>
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-144">{error}</p>}
    </div>;
}
export function SearchInput({
  className = '',
  ...props
}: Omit<InputProps, 'icon'>) {
  return <Input icon={<Search className="h-4 w-4" data-id="element-146" />} placeholder="Search..." className={className} {...props} data-id="element-145" />;
}